export default "__VITE_ASSET__DqIRCj$P__"